import {Client, createClient, getRepositoryEndpoint} from '@prismicio/client';
import {PrismicDocument} from '@prismicio/types';

export async function getNavbarDocument(locale: string): Promise<PrismicDocument> {
    const client = getPrismicClient();
    return client.getSingle<PrismicDocument>('malt-header', {lang: locale.toLowerCase()});
}

export function getPrismicClient(): Client {
    const {prismic} = window.__NAVBAR_UNLOGGED__;

    const cache = prismic.cache;
    const repository = prismic.repository;
    const token = prismic.token;

    if (cache) {
        return createClient(`${window.location.origin}/cms/api/prismic`, {accessToken: token});
    }
    const endpoint = getRepositoryEndpoint(repository);
    return createClient(endpoint, {accessToken: token});
}
